import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { LDContext } from 'launchdarkly-react-client-sdk'

const anonymousContext: LDContext = { kind: 'user', key: 'anonymous' }

interface LDContextState {
    context: LDContext
    setContext: (context: LDContext) => void
    resetContext: () => void
}

export const LDContextStore = create<LDContextState>()(
    devtools(
        persist(
            (set) => ({
                context: anonymousContext,
                setContext: (context: LDContext) => set({ context }),
                resetContext: () => set({ context: anonymousContext }),
            }),
            { name: 'edge-ld-context' },
        ),
        { name: 'LDContextStore' },
    ),
)

export const useLDContextStore = () => LDContextStore((state) => state.context)
export const getLDContextStore = () => LDContextStore.getState().context ?? anonymousContext
export const setLDContextStore = (context: LDContext) => LDContextStore.getState().setContext(context)
export const resetLDContextStore = () => LDContextStore.getState().resetContext()
